import { Box, styled } from '@mui/material';
import { EllipsisText, CreatedCell, CreatorCell, StatusCell } from './RecentRow';
import { DetailsCell, GroupCountCell, NameCell } from './RecentReportRow';

const HeaderRow = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  gap: '12px',
  padding: '0 8px 4px',
  borderBottom: `1px solid ${theme.palette.divider}`,
  '& .MuiTypography-root': {
    fontSize: '0.75rem',
    fontWeight: 600,
    color: theme.palette.text.secondary,
  },
}));

const HeaderColumns = styled(Box)({
  display: 'flex',
  alignItems: 'center',
  gap: '12px',
  flex: 1,
  minWidth: 0,
});

export const ReportsTileHeader = () => (
  <HeaderRow data-testid='reports-tile-header'>
    <HeaderColumns>
      <NameCell>
        <EllipsisText>Report</EllipsisText>
      </NameCell>
      <DetailsCell>
        <EllipsisText>Filters</EllipsisText>
      </DetailsCell>
      <GroupCountCell>Groups</GroupCountCell>
      <CreatorCell>Created by</CreatorCell>
      <CreatedCell>Created</CreatedCell>
    </HeaderColumns>
    <StatusCell>
      <EllipsisText>Status</EllipsisText>
    </StatusCell>
  </HeaderRow>
);
